import * as request from './utils/requester';

export const getAll = (page) => request.get(`/request?page=${page}`);

export const getById = (id) => request.get(`/request/${id}`);

export const create = (data) => request.post('/request', data);

export const edit = (data) => request.put(`/request/${data._id}`, data);

export const del = (data) => request.del(`/request/${data._id}`);

export const getOption = (option) => request.get(`/request?option=${option}`);

export const getOptionId = (option, id) => request.get(`/request/${id}?option=${option}`);
